export const styleBorderGlow = 'drop-shadow(0px 0px 4px #2F80ED)'
